import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'LIVE_CLASS_WAITING_LIST_ERROR':
      return action.error;

    case 'LIVE_CLASS_WAITING_LIST_MERCURE_DELETED':
      return `${action.retrieved['@id']} has been deleted by another user.`;

    case 'LIVE_CLASS_WAITING_LIST_RESET':
      return null;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'LIVE_CLASS_WAITING_LIST_LOADING':
      return action.loading;

    case 'LIVE_CLASS_WAITING_LIST_RESET':
      return false;

    default:
      return state;
  }
}

export function retrieved(state = null, action) {
  switch (action.type) {
    case 'LIVE_CLASS_WAITING_LIST_SUCCESS':
    case 'LIVE_CLASS_WAITING_LIST_MERCURE_MESSAGE':
      return action.retrieved;

    case 'LIVE_CLASS_WAITING_LIST_RESET':
      return null;

    default:
      return state;
  }
}

// export function eventSource(state = null, action) {
//   switch (action.type) {
//     case 'PROJECT_LIST_MERCURE_OPEN':
//       return action.eventSource;

//     case 'PROJECT_LIST_RESET':
//       return null;

//     default:
//       return state;
//   }
// }

export default combineReducers({ error, loading, retrieved });
